import { Clerk } from '@clerk/clerk-js';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

let clerkInstance: Clerk | null = null;
let loadingPromise: Promise<Clerk> | null = null;

/**
 * Singleton Clerk loader. Resolves to a fully-loaded Clerk instance.
 * Throws if VITE_CLERK_PUBLISHABLE_KEY is missing — that would mean
 * deploy-time configuration drift, not a recoverable runtime error.
 */
export function loadClerk(): Promise<Clerk> {
  if (clerkInstance) return Promise.resolve(clerkInstance);
  if (loadingPromise) return loadingPromise;

  if (!PUBLISHABLE_KEY) {
    return Promise.reject(
      new Error('VITE_CLERK_PUBLISHABLE_KEY is not set — check apps/pwa/.env'),
    );
  }

  loadingPromise = (async () => {
    const c = new Clerk(PUBLISHABLE_KEY);
    await c.load();
    clerkInstance = c;
    return c;
  })();

  return loadingPromise;
}
